import { FC, ReactNode } from "react";
import {Popover as HeadlessPopover} from "@headlessui/react";

interface Props {
  trigger: ReactNode
}

const Popover: FC<Props> = (props) => {
  return (
    <HeadlessPopover className="relative">
      <HeadlessPopover.Button>
        {props.trigger}
      </HeadlessPopover.Button>

      <HeadlessPopover.Panel className='absolute z-10'>
        {props.children}
      </HeadlessPopover.Panel>
    </HeadlessPopover>
  );
};

export default Popover;